import { render, staticRenderFns } from "./PayError.vue?vue&type=template&id=550dd4fc&"
import script from "./PayError.vue?vue&type=script&lang=js&"
export * from "./PayError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports